import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-sidebar.js';
import { makeRouter } from '@adornis/router/client/make-router.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-writer/cr-writer-toolbar.js';
import '@chancenwerk/design/components/fonts.js';
import { watch } from '@lit-labs/preact-signals';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import './pages/anmeldung-page-acquisition.js';
import './pages/anmeldung-page-chancenfamily.js';
import './pages/anmeldung-page-declaration.js';
import './pages/anmeldung-page-registration-graduation.js';
import './pages/anmeldung-page-registration-os.js';
import './pages/anmeldung-page-registration-us.js';
import './pages/anmeldung-page-workshop-management.js';
import './pages/anmeldung-page-workshop-registration.js';
import { AnmeldungFirstLevelPage, AnmeldungRoutes, AnmeldungSecondLevelPage } from './routes.js';

const router = makeRouter({
  root: {
    path: '/',
    render: () => {
      return html`
        <cr-flex space="md" ${css({ margin: 'auto' })}>
          <cr-button @click=${() => goTo(AnmeldungRoutes.registerFormUs)}> Anmeldeformular Lernkaskade </cr-button>
          <cr-button @click=${() => goTo(AnmeldungRoutes.registerFormOs)}> Anmeldeformular CHANCENreise </cr-button>
          <!--
          
          <cr-button @click=${() => goTo(AnmeldungRoutes.registerFormGraduation)}>
            Anmeldeformular CHANCENabschluss
          </cr-button>

          -->
        </cr-flex>
      `;
    },
  },
  [AnmeldungFirstLevelPage.ACQUISITION]: {
    path: `/${AnmeldungFirstLevelPage.ACQUISITION}`,
    render: () => html`<anmeldung-page-acquisition></anmeldung-page-acquisition>`,
  },
  'register-os': {
    path: `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.OS}`,
    render: () => html`<anmeldung-page-registration-os></anmeldung-page-registration-os>`,
  },
  'register-us': {
    path: `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.US}`,
    render: () => html`<anmeldung-page-registration-us></anmeldung-page-registration-us>`,
  },
  'register-graduation': {
    path: `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.GRADUATION}`,
    render: () => html`<anmeldung-page-registration-graduation></anmeldung-page-registration-graduation>`,
  },
  'register-declaration': {
    path: `/${AnmeldungFirstLevelPage.REGISTER}/${AnmeldungSecondLevelPage.DECLARATION}`,
    render: () => html`<anmeldung-page-declaration></anmeldung-page-declaration>`,
  },
  'workshop-registration': {
    path: `/${AnmeldungFirstLevelPage.WORKSHOP}/${AnmeldungSecondLevelPage.REGISTRATION}/:workshopId`,
    render: ({ workshopId }) => html`
      <anmeldung-page-registration-workshop-registration
        .workshopID=${workshopId}
      ></anmeldung-page-registration-workshop-registration>
    `,
  },
  'workshop-management': {
    path: `/${AnmeldungFirstLevelPage.WORKSHOP}/${AnmeldungSecondLevelPage.MANAGEMENT}/:workshopId`,
    render: ({ workshopId }) => html`
      <anmeldung-page-registration-workshop-management
        .workshopID=${workshopId}
      ></anmeldung-page-registration-workshop-management>
    `,
  },
  chancenfamily: {
    path: `/chancenfamily/:id`,
    render: ({ id }) => html`<anmeldung-page-chancenfamily .eventID=${id}></anmeldung-page-chancenfamily>`,
  },
}).init();

@customElement('main-element')
export class MainElement extends ChemistryLitElement {
  override styles() {
    return [
      {
        ':host': {
          background: this.colors.neutral.shade(50),
        },
      },
    ];
  }

  size = new WindowSizeController(this);

  override connectedCallback(): void {
    super.connectedCallback();
    globalLanguageSubject.next(Language.GERMAN);
  }

  override render() {
    return html` <cr-flex h100 w100 ${css({ overflowY: 'auto' })}> ${watch(router.outlet)} </cr-flex> `;
  }
}
